export const MONITOREO_EN_PROCESO = {
  value: 1,
  label: 'En proceso'
};
export const MONITOREO_TERMINADO = {
  value: 2,
  label: 'Terminado'
};
export const MONITOREO_CANCELADO = {
  value: 3,
  label: 'Cancelado'
};

export const HALLAZGO_VALIDADO = {
  value: 4,
  label: 'Validado'
};
